import { createRoute, redirect } from '@tanstack/react-router'

import { rootRoute } from '@/routes/root'
import { ensureAuthenticatedUser } from '@/utils/auth-wall'
import { Features } from '@/utils/featureFlag/features'

import { DashboardErrorComponent } from './view/dashboardErrorComponent'
import { DashboardSkeleton } from './view/dashboardSkeleton'

export const dashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/dashboard',
  beforeLoad: async ({ context, location }) => {
    await ensureAuthenticatedUser({ context, location })
    if (context.isFeatureEnabled && !context.isFeatureEnabled(Features.SHIP_V2_DASHBOARD)) {
      throw redirect({
        to: '/',
      })
    }
  },
  // Starts every dashboard request while the page chunk loads, so the widgets mount with the data already in flight.
  // The dynamic import keeps the fetchers out of the eager route bundle; the prefetch itself is not awaited.
  loader: async ({ context }) => {
    if (!context.queryClient || !context.customer) {
      return
    }
    const { prefetchDashboardQueries } = await import('./api/prefetchDashboardQueries')
    prefetchDashboardQueries(context.queryClient, context.customer._id)
  },
  pendingComponent: DashboardSkeleton,
  errorComponent: DashboardErrorComponent,
}).lazy(() => import('./view/dashboard').then((d) => d.Route))
